import type { Address } from 'viem'

const addressRegex = /^0x[a-fA-F0-9]{40}$/
export const isAddress = (address: string): address is Address => addressRegex.test(address)
